import React, { forwardRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { WarningRounded, CheckRounded, Close } from "@material-ui/icons";
import {
  TableContainer,
  Paper,
  TableHead,
  TableBody,
  Table,
  TableRow,
  TableCell,
  Grid,
  Button,
  Avatar,
  IconButton,
  Tooltip,
  Checkbox,
  Dialog,
  Slide,
  AppBar,
  Toolbar,
  Typography,
  FormControl,
  FormControlLabel,
} from "@material-ui/core";
import { PARENTESCOS, TIPO_DOCUMENTO } from "../../../../utils/constants";
import { ValidatorForm } from "react-material-ui-form-validator";
import { startAlerta } from "../../../../actions/ui/alertas";
import { enviarReactivacionPorLote } from "../../../../actions/afiliado/afiliadoReactivacionAction";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import ValidatedDatePicker from "../../../compartidos/ValidatedDatePicker";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import { fetchConToken } from "../../../../helpers/fetch";

const optionsFecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

const style = {
  root: {
    flex: 1,
    width: "100%",
  },
  container: {
    marginTop: 70,
    width: "100%",
  },
  appBar: {
    position: "relative",
    width: "100%",
  },
  iconMed: {
    fontSize: 18,
    display: "flex",
    alignItems: "center",
  },
  avatarWarnVisible: {
    margin: 2,
    backgroundColor: "red",
    width: 22,
    height: 22,
    display: "flex",
    alignItems: "center",
  },
};

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const ReactivacionesModal = ({ abrirModal, setAbrirModal, idGrupo }) => {
  const dispatch = useDispatch();
  let history = useHistory();

  const [afiliadosChecked, setAfiliadosChecked] = useState([]);
  const [validarDocu, setvalidarDocu] = useState(true);
  const [fecha, setFecha] = useState("");

  const { items, cargada: listaFamiliaresCargada } = useSelector((state) =>
    idGrupo !== "idGrupoFamiliarPreinscripto"
      ? state.grupofamiliar
      : state.grupofamiliarPreinscripto
  );
  const { items: localidades, cargada: localidadesCargada } = useSelector((state) => state.localidades);
  const { items: provincias, cargada: provinciasCargada } = useSelector((state) => state.provincias);
  const { idUsuario } = useSelector((state) => state.auth);
  const { consultaAfiliado } = useSelector((state) => state.afiliacion);

  const itemsAMostrar=consultaAfiliado.id_parentesco===PARENTESCOS.TITULAR ? items : items.filter(item=>item.id_afiliado===consultaAfiliado.id_afiliado);
  
  const handleCloseSlideModal = () => {
    setAbrirModal(false);
  };

  const handleValidarChange = (e) => {
    setvalidarDocu(e.target.checked);
  };

  const handlerAfterReactivacion = async () => {
    
    const response = await fetchConToken(
      `Afiliados/traerTitularPorCUIL/${consultaAfiliado.cuil}`
    );

    if (response.ok) {
      const contentType = response.headers.get("content-type");

      if (contentType && contentType.indexOf("application/json") !== -1) {
        const titular = await response.json();

        if (!!titular) {
          history.push("/afiliaciones", {
            from: "/afiliaciones/reactivaciones",
            afiliadoSelec: titular,
          });
        }
      }
    }
  };

  const handleAfiliadoCheckedChange = (e) => {
    if (e.target.checked) {
      setAfiliadosChecked([...afiliadosChecked, parseInt(e.target.value)]);
    } else {
      setAfiliadosChecked(
        afiliadosChecked.filter(
          (el) => parseInt(el) !== parseInt(e.target.value)
        )
      );
    }
  };

  const handleSubmitReactivacion = (e) => {
    e.preventDefault();
    if (afiliadosChecked.length === 0) {
      dispatch(
        startAlerta(
          "Debe seleccionar al menos un integrante del grupo familiar",
          "error"
        )
      );
    } else {
      dispatch(
        enviarReactivacionPorLote(
          afiliadosChecked,
          idUsuario,
          fecha,
          validarDocu,
          handlerAfterReactivacion
        )
      );
    }
  };

  return (
    <div className={style.root}>
      <Dialog
        fullScreen
        open={abrirModal}
        onClose={handleCloseSlideModal}
        TransitionComponent={Transition}
      >
        <AppBar className={style.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleCloseSlideModal}
              aria-label="close"
            >
              <Close />
            </IconButton>
            <Typography variant="h6">REACTIVACIÓN</Typography>
          </Toolbar>
        </AppBar>
        <div>
          {listaFamiliaresCargada && (
            <TableContainer style={style.container} component={Paper}>
              <Table responsive>
                <TableHead>
                  <TableRow>
                    <TableCell align="left"></TableCell>
                    <TableCell align="left">Apellido y Nombre</TableCell>
                    <TableCell align="left">Nro Documento</TableCell>
                    <TableCell align="left">Parentesco</TableCell>
                    <TableCell align="left">Fecha Nacimiento</TableCell>
                    <TableCell align="left">Localidad</TableCell>
                    <TableCell align="left">Provincia</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {itemsAMostrar.flatMap((afiliado) =>
                    afiliado.fecha_baja !== null ? (
                      <TableRow key={afiliado.id_afiliado}>
                        <TableCell align="left">
                          <Checkbox
                            value={afiliado.id_afiliado}
                            checked={afiliadosChecked.includes(
                              afiliado.id_afiliado
                            )}
                            color="primary"
                            onChange={handleAfiliadoCheckedChange}
                            inputProps={{ "aria-label": "secondary checkbox" }}
                          />
                        </TableCell>
                        <TableCell align="left">
                          <Grid container spacing={1}>
                            <Avatar style={style.avatarWarnVisible}>
                              <Tooltip
                                title="Afiliado dado de baja"
                                placement="right-start"
                              >
                                <WarningRounded style={style.iconMed} />
                              </Tooltip>
                            </Avatar>
                            <div style={{ paddingTop: "5px" }}>
                              {afiliado.apellido_y_nombre.toUpperCase()}
                            </div>
                          </Grid>
                        </TableCell>
                        <TableCell align="left">
                          {afiliado.id_tipo_documento === TIPO_DOCUMENTO.DNI &&
                            "DNI"}
                          {afiliado.id_tipo_documento ===
                            TIPO_DOCUMENTO.CEDULA_IDENTIDAD && "CI"}
                          {afiliado.id_tipo_documento ===
                            TIPO_DOCUMENTO.LIBRETA_ENROLAMIENTO && "LE"}
                          {afiliado.id_tipo_documento ===
                            TIPO_DOCUMENTO.LIBRETA_CIVICA && "LC"}
                          {afiliado.id_tipo_documento ===
                            TIPO_DOCUMENTO.PASAPORTE && "PAS"}
                          {afiliado.id_tipo_documento === TIPO_DOCUMENTO.NI &&
                            "NI"}
                          {afiliado.id_tipo_documento === TIPO_DOCUMENTO.RN &&
                            "RN"}
                          {`  ${afiliado.nro_doc}`}
                        </TableCell>
                        <TableCell align="left">
                          {afiliado.id_parentesco === PARENTESCOS.TITULAR &&
                            "TITULAR"}
                          {afiliado.id_parentesco === PARENTESCOS.CONYUGE &&
                            "CONYUGE"}
                          {afiliado.id_parentesco === PARENTESCOS.CONCUBINA_O &&
                            "CONCUBINA/O"}
                          {afiliado.id_parentesco === PARENTESCOS.HIJO_MENOR &&
                            "HIJO MENOR"}
                          {afiliado.id_parentesco ===
                            PARENTESCOS.HIJO_ESTUDIANTE && "HIJO ESTUDIANTE"}
                          {afiliado.id_parentesco ===
                            PARENTESCOS.FAMILIAR_A_CARGO && "FLIAR.A CARGO"}
                          {afiliado.id_parentesco ===
                            PARENTESCOS.HIJO_DISCAPACITADO &&
                            "HIJO DISCAPACITADO"}
                          {afiliado.id_parentesco ===
                            PARENTESCOS.MENOR_BAJO_GUARDA_O_TUTELA &&
                            "MENOR BAJO GUARDA"}
                          {afiliado.id_parentesco ===
                            PARENTESCOS.HIJO_CONYUGE && "HIJO CONYUGE"}
                          {afiliado.id_parentesco ===
                            PARENTESCOS.HIJO_CONYUGE_ESTUDIANTE &&
                            "HIJO CONYUGE ESTUDIANTE"}
                        </TableCell>
                        <TableCell align="left">
                          {new Date(afiliado.fecha_nacimiento).toLocaleString(
                            "es",
                            optionsFecha
                          )}
                        </TableCell>
                        <TableCell align="left">
                          {localidadesCargada &&
                            localidades.find(
                              (loc) =>
                                loc.id_localidad ===
                                afiliado.domiciliosAfiliados?.id_localidad
                            )?.descripcion_localidad}
                        </TableCell>
                        <TableCell align="left">
                          {provinciasCargada &&
                            provincias.find(
                              (prov) =>
                                prov.id_provincia ===
                                afiliado.domiciliosAfiliados?.id_provincia
                            )?.descripcion_provincia}
                        </TableCell>
                      </TableRow>
                    ) : null
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
          <ValidatorForm onSubmit={handleSubmitReactivacion}>
            <Grid container justify="flex-end">
              <Grid item xs={3} style={{ paddingLeft: 30 }}>
                <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                  <ValidatedDatePicker
                    margin="normal"
                    id={"dialogFecVigencia"}
                    label="Fec. Vigencia"
                    format="dd/MM/yyyy"
                    okLabel="Aceptar"
                    maxDate={moment(new Date()).add(3, "M")}
                    clearLabel="Limpiar"
                    cancelLabel="Cancelar"
                    value={moment(fecha).isValid() ? moment(fecha) : null}
                    onChange={setFecha}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    validators={["required"]}
                    errorMessages={["Fecha de Vigencia es requerida"]}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={3} style={{ paddingTop: 10 }}>
                <FormControl fullWidth={true} margin="normal">
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="validarDocumentacion"
                        checked={validarDocu}
                        onChange={handleValidarChange}
                      />
                    }
                    label="Controlar Documentación"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <Button
                  variant="contained"
                  color="secondary"
                  style={{ marginTop: 20, marginLeft: "65%" }}
                  type="submit"
                  startIcon={<CheckRounded />}
                >
                  Realizar Reactivación
                </Button>
              </Grid>
            </Grid>
          </ValidatorForm>
        </div>
      </Dialog>
    </div>
  );
};
